export const SET_CURRENT_USER = 'SET_CURRENT_USER'
export const SET_USER_TOKEN = 'SET_USER_TOKEN'
export const SET_HAS_MEMBERSHIP_ACCESS = 'SET_HAS_MEMBERSHIP_ACCESS'
export const ADD_INVITE_CODE = 'ADD_INVITE_CODE'
export const SET_INVITE_CODES = 'SET_INVITE_CODES'
export const SET_SELECTED_MEMBERSHIP_TYPE = 'SET_SELECTED_MEMBERSHIP_TYPE'

export const SET_SQUARE_STATUS = 'SET_SQUARE_STATUS'
export const SET_STRIPE_STATUS = 'SET_STRIPE_STATUS'

export const SET_MESSAGE = 'SET_MESSAGE'
export const SET_IS_LOADING = 'SET_IS_LOADING'
export const SET_IS_ERROR = 'SET_IS_ERROR'
export const SET_LAST_ERROR = 'SET_LAST_ERROR'

export const SET_TICKETS_URI = 'SET_TICKETS_URI'

export const SET_HIDE_UPGRADE_WALL = 'SET_HIDE_UPGRADE_WALL'

export const SET_HIDE_ACTION_REQUIRED = 'SET_HIDE_ACTION_REQUIRED'

export const SET_PRESET_COUPON_CODE = 'SET_PRESET_COUPON_CODE'
export const SET_SELECTED_MEMBERSHIP_COUPON = 'SET_SELECTED_MEMBERSHIP_COUPON'
export const SET_MEMBERSHIP_SCAN_PENDING = 'SET_MEMBERSHIP_SCAN_PENDING'
